export const strings = {
  brandName: "Spec's Nightlife & Party Supplies",
  brandNameShort: "Spec's Nightlife",
  brandTagline: "Boost Bottle Sales. Elevate Guest Experiences.",
  brandDescription: "Elevate your VIP experience with high-end bottle service supplies—LED trays, sparklers, buckets & signage. Get reliable bottle service and party supplies delivered fast.",
  brandAddress: "2410 Smith Street Houston, TX 77006",
  siteUrl: "https://specsnightlife.com",
  siteUrlNiceName: "specsnightlife.com",
  siteBrandPath: "partysupplies",
  uploadsPath: "/images/uploads/",
  contactUs: {
    hero: "/images/pages/contact-us-header.jpg"
  },
  membershipName: "Key Club",
  supportEmail: "contactus@specsnightlife.com",
  legalEmail: "contactus@specsnightlife.com",
  phoneNumber: "1-713-898-3103",
  logo: {
    primary: "/images/brands/partysupplies/logo.svg",
    bug: "/images/brands/partysupplies/logo-before.svg",
  },
  loyaltyProgram: {
    name: "Key Club",
    description: "The Spec's Key Club is your FREE pass to everything Spec's. Purchases accumulate points, which are used to determine your membership level. You earn different benefits at each level, such as invitations to exclusive events and birthday gifts. More benefits will be added soon!",
    url: "keyclub",
    joinUrl: "join-keyclub",
    logo: "/images/brands/specs/loyalty-program/rewards-logo.png",
    icon: "/images/brands/specs/loyalty-program/rewards-icon.svg",
    nameTier1: "Red",
    nameTier2: "Gold",
    nameTier3: "Platinum",
    nameTier4: "Black",
    iconTier1: "/images/brands/specs/loyalty-program/tier-1-icon.png",
    iconTier2: "/images/brands/specs/loyalty-program/tier-2-icon.png",
    iconTier3: "/images/brands/specs/loyalty-program/tier-3-icon.png",
    iconTier4: "/images/brands/specs/loyalty-program/tier-4-icon.png",
    joinSlogan: "Get <span>the</span> bunny love",
    supportEmail: "keyclub@specsonline.com",
    textToJoinCode: "SPECS"
  },
  promotions: {
    hugeWineSale: {
      hero: {
        src: "/images/mock/home/hero/SPECS_Slider_Website-Desktop_HugeWineSale-1920x450.jpg",
        srcMedium: "/images/mock/home/hero/SPECS_Slider_Website_HugeWineSale-1000x272.jpg",
        srcSmall: "/images/mock/home/hero/SPECS_Slider_Website_HugeWineSale-768x400.jpg",
        alt: "Huge Wine Sale",
        href: "/shop/wine/",
      }
    }
  }
} as const;
